/* eslint-disable no-useless-escape */
import { CompositeDecorator } from 'draft-js';
import { HandleSpan } from 'components/decorators/spellchecks';

export const generateDecorator = decos => {
	return new CompositeDecorator([
		{
			strategy: (contentBlock, callback) => {
				if (decos.length > 0) {
					const _decos = decos
						.filter(x => x.blockKey === contentBlock.getKey())
						.filter(x => x.orgStr != null);
					if (_decos.length > 0) {
						const _orgStr = _decos.map(
							d =>
								'([^\uac00-\ud7a3])' +
								d.orgStr.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&').trim() +
								'(?=[^\uac00-\ud7a3])'
						);
						if (_orgStr.length > 0) {
							const regex = new RegExp(_orgStr.join('|'), 'g');
							const blockLength = contentBlock.getLength();
							let matchArr, start;
							while (
								(matchArr = regex.exec(' ' + contentBlock.getText().replace(/[\(\)\']/, ' ') + ' ')) !==
								null
							) {
								start = matchArr.index;
								const end = Math.min(start + matchArr[0].trim().length, blockLength);
								// 앞뒤 공백을 덧댄 문자열에서 찾기 때문에 블록 범위를 벗어날 수 있다.
								if (start < end) callback(start, end);
							}
						}
					}
				}
			},
			component: HandleSpan,
			props: { decos },
		},
	]);
};
